export default __webpack_public_path__ + "atomic/_patterns/01-atoms/form-element-textfield/_form-element-textfield.twig";